import { useState } from 'react';
import axios from "axios";
import { API_URL, APP_URL } from "../../../config";
import form from "./schemas/form";
import validations from "./schemas/validations";
import initialValues from "./schemas/initialValues";
import {recoverPasswordService, signInService} from "../../../services/authService";

export const useRecoverPassword = () => {

    const {formId, formField} = form

    const [snackbarConfig, setSnackbarConfig] = useState({
        color: 'success',
        title: '',
        message: '',
        icon: 'notifications'
    });

    const [show, setShow] = useState(false);
    const toggleSnackbar = () => setShow(!show);

    const submitForm = async (values, actions) => {

        try {

            await axios.get(`${APP_URL}/sanctum/csrf-cookie`);

            const response = await recoverPasswordService(values);

            actions.resetForm();

            setSnackbarConfig({
                message: response.data.message,
                icon: 'notifications',
                title: 'Autenticación',
                color: 'success'
            });

            setShow(true);

        } catch (error) {

            setSnackbarConfig({
                message: error.response.data.message,
                icon: 'cancel',
                title: 'Autenticación',
                color: 'warning'
            });

            setShow(true);

        }

        actions.setSubmitting(false);

    };

    return {
        formId,
        formField,
        validations,
        initialValues,
        show,
        toggleSnackbar,
        submitForm,
        snackbarConfig
    };
};
